var Asset;

Asset = function(self) {
  Modelize(self, {
    api: api.assets,
    editable: ['description', 'inventory_number']
  });
  Selectable(self);
  Purchasable(self);
  Editable(self, 'name', (function(_this) {
    return function(new_name) {
      if (new_name === '') {
        return true;
      }
      self.api().update(self.id, {
        name: self.name()
      });
      return self.loading(false);
    };
  })(this));
  Observable(self, 'is_cover');
  Observable(self, 'loading');
  Observable(self, 'items_amount');
  ObservableArray(self, 'tags', []);
  ObservableArray(self, 'items', []);
  ObservableArray(self, 'albums', []);
  ObservableArray(self, 'galleries', []);
  self.remove_item = (function(_this) {
    return function(item) {
      if (confirm('Are you sure you want to remove this item option?')) {
        return item["delete"](function() {
          return self.items.remove(function(i) {
            return i.id === item.id;
          });
        });
      }
    };
  })(this);
  self.add_item = (function(_this) {
    return function() {
      return Item.create(self.id, {
        kaschiert: 0,
        shop_category_id: shop_category,
        virtual: shop_virtual
      }, function(data) {
        if (!data.errors) {
          self.items.push(Item(data));
          return Item.create(self.id, {
            kaschiert: 1,
            shop_category_id: shop_category,
            virtual: shop_virtual,
            pair: data.id
          }, function(data) {
            return self.items.push(Item(data));
          });
        } else {
          return alert(data.errors);
        }
      });
    };
  })(this);
  self.add_tag = (function(_this) {
    return function(tag, callback) {
      if (self.has_tag(tag)) {
        return;
      }
      self.loading(true);
      return api.assets.tags.create(self.id, {
        tag_id: tag.id
      }).done(function(data, e) {
        if (callback != null) {
          callback(data, e);
        }
        if (!self.has_tag(tag)) {
          self.tags.push(tag);
        }
        return self.loading(false);
      });
    };
  })(this);
  self.remove_tag = (function(_this) {
    return function(tag_id, callback) {
      return api.assets.tags.destroy(self.id, tag_id).done(callback);
    };
  })(this);
  self.add_tag_ui = (function(_this) {
    return function(data, event) {
      var tag, tag_name;
      tag_name = $('#tag_name_info').val();
      tag = null;
      return Tag.create(tag_name, function(data) {
        tag = Tag(data);
        self.add_tag(tag);
        return $('#tag_name_info').val('');
      });
    };
  })(this);
  self.remove_tag_ui = (function(_this) {
    return function(tag) {
      return self.remove_tag(tag.id, function() {
        return self.tags.remove(tag);
      });
    };
  })(this);
  self.has_tag = (function(_this) {
    return function(tag) {
      var t, _i, _len, _ref;
      if (self.tags().length === 0) {
        return false;
      }
      _ref = self.tags();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        t = _ref[_i];
        if (tag.id === t.id) {
          return true;
        }
      }
      return false;
    };
  })(this);
  self.has_tags = (function(_this) {
    return function(tags) {
      var r, tag, _i, _len;
      if (tags.length === 0) {
        return true;
      }
      r = [];
      for (_i = 0, _len = tags.length; _i < _len; _i++) {
        tag = tags[_i];
        if (self.has_tag(tag)) {
          r.push(true);
        }
      }
      return r.length === tags.length;
    };
  })(this);
  return self;
};

api.add('assets');

api.assets.add('tags');

api.assets.add('iptc');

api.assets.add('albums');

api.assets.add('galleries');

Asset.find = function(asset_id, options, callback) {
  return api.assets.read(asset_id, options).done(callback);
};

//# sourceMappingURL=asset.js.map
